<!-- Título -->
<h2 class="title">Contratos y renovaciones</h2>

<!-- Botones, combo y barra de búsqueda -->
<app-page-acciones
  [hasButton]="false"
  [comboOptions]="monthOptions"
  [comboSelected]="currentMonth"
  (comboSelectedChange)="onMonthChange($event)"

  [yearOptions]="yearOptions"
  [yearSelected]="selectedYear"
  (yearSelectedChange)="onYearChange($event)"
  
  [searchQuery]="searchTerm"
  (searchQueryChange)="onSearch($event)"
>
</app-page-acciones>

<!-- Tabs y tabla dinámica -->
<app-page-container
  [contentContainerClass]="'contract-container'"
  [tabs]="tabs"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [actionButtons]="actionButtons"
  [headerClass]="currentHeaderClass"
  [showPreviewCard]="false"
  [isLoading]="isLoading"
  [useServerPagination]="true"
  [paginationLength]="totalElements"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [customTemplates]="{
    employeeName: employeeNameTemplate,
    jobPositionName: jobPositionNameTemplate,
    salary: salaryTemplate,
    startDateContract: startDateTemplate,
    endDate: endDateTemplate,
    stateContract: stateContractTemplate,
    fileContract: fileContractTemplate
  }"
  (tabSelected)="onTabSelected($event)"
  (rowSelected)="onRowSelected($event)"
  (pageChange)="onPageChange($event)"
  [hasCheckbox]="true"
>
  <ng-template #employeeNameTemplate let-row>
    <span class="truncate-text">{{ getEmployeeName(row) | capitalize }}</span>
  </ng-template>
  <ng-template #jobPositionNameTemplate let-row>
    <span class="truncate-text">{{ (row.jobPositionName || '-') | capitalize }}</span>
  </ng-template>
  <ng-template #salaryTemplate let-row>
    <span *ngIf="row.salary !== null && row.salary !== undefined">S/. {{ row.salary }}</span>
    <span *ngIf="row.salary === null || row.salary === undefined">-</span>
  </ng-template>
  <ng-template #startDateTemplate let-row>
    {{ formatDate(row.startDateContract) || '-' }}
  </ng-template>
  <ng-template #endDateTemplate let-row>
    {{ formatDate(row.endDate) || '-' }}
  </ng-template>
  <ng-template #stateContractTemplate let-row>
    <span [ngClass]="['contract-status-pill', getContractStatusClass(row)]">
      {{ getContractStatus(row) }}
    </span>
  </ng-template>
  <ng-template #fileContractTemplate let-row>
    <span class="truncate-text">
      <!-- Botón Aceptar -->
      <button
        type="button"
        (click)="onDetail(row)"
        [disabled]="!isSelected(row)"
        class="btn-detail"
      >
        <i [ngClass]="hasContract(row) ? 'pi pi-eye' : 'pi pi-file-plus'"></i>
        <span>{{ hasContract(row) ? 'Ver detalle' : 'Completar' }}</span>
      </button>
    </span>
  </ng-template>
</app-page-container>

<!-- Modal del detalle -->

<div class="contract-edit-modal">
  <app-contract-edit-modal
    [(visible)]="mostrarModalEditar"
    [dataToEdit]="dataToEdit"
    (visibleChange)="onDialogClose()"
    (editComplete)="onEditComplete()"
  ></app-contract-edit-modal>
</div>

<div class="contract-validate-modal">
  <app-contract-validate-modal
    [(visible)]="mostrarModalValidar"
    [dataToView]="dataToEdit"
    (visibleChange)="onDialogDetailClose()"
    (updateStateComplete)="onUpdateStateComplete()"
  >
  </app-contract-validate-modal>
</div>

<div class="modal-not-permission">
  <app-modal-not-permission
    [(visible)]="viewDeleted"
    [id]="contractId"
    (visibleChange)="onDialogDetailClose()"
  ></app-modal-not-permission>
</div>
